import { render, staticRenderFns } from "./lpProdDeliveryPrice.vue?vue&type=template&id=3ac04d1e&scoped=true"
import script from "./lpProdDeliveryPrice.vue?vue&type=script&lang=js"
export * from "./lpProdDeliveryPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac04d1e",
  null
  
)

export default component.exports